const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/components/CIS4mMaskedTextField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { TextFieldProps, useTheme } from '@mui/material';
import { useCIS4mValidation } from '../hooks';
import textMap from './translations';
import { useOptionalText, useText } from '../../../utils/intlUtils';
import { useCIS4mContext } from '../context';
import { MaskedTextField } from '@cistec/common_web/components/MaskedTextField/MaskedTextField';
import { CIS4mTextFieldProps } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';

export interface CIS4mMaskedTextFieldProps extends Omit<CIS4mTextFieldProps, 'multiline'> {
    mask: string;
}

const sxTextField: TextFieldProps['sx'] = {
    mt: 0.5,
    mb: 0.5,
};

export const CIS4mMaskedTextField = forwardRef((props: CIS4mMaskedTextFieldProps, ref: any) => {
    const {
        path,
        initialValue,
        required = false,
        hidden = false,
        readonly,
        disabled = false,
        className,
        checkValidity,
        mask,
    } = props;
    const { variant } = useCIS4mContext().style;

    const theme = useTheme();
    const label = useText(props.label);
    const helperText = useOptionalText(props.helperText);

    const [value, setValue, errorMessage] = useCIS4mValidation(ref, {
        checkValidity: checkValidity
            ? checkValidity
            : () => {
                  if (
                      mask !== undefined &&
                      mask.trim().length !== 0 &&
                      value.replaceAll('_', '').length !== mask.length
                  ) {
                      return textMap.formatDoesNotMatch;
                  }
              },
        disabled,
        hidden,
        initialValue,
        path,
        required,
    });

    return hidden ? null : (
        <MaskedTextField
            label={label}
            className={className}
            variant={variant}
            fullWidth
            size={'small'}
            value={value || ''}
            onChange={(event: any) => {
                setValue(event.target.value);
            }}
            mask={mask}
            slotProps={{
                input: {
                    readOnly: readonly,
                    inputProps: mask ? { mask } : { maxLength: props.maxLength },
                    style: { color: props.color === 'inversed' ? theme.palette.common.white : undefined },
                },
                inputLabel: {
                    style: { color: props.color === 'inversed' ? theme.palette.common.white : undefined },
                },
            }}
            color={props.color === 'inversed' ? undefined : !!errorMessage ? 'error' : 'primary'}
            required={required}
            disabled={disabled}
            hidden={hidden}
            error={!!errorMessage}
            helperText={errorMessage || helperText} // errorMessage will have more priority than helperText when there is one
            sx={sxTextField}
        />
    );
});
CIS4mMaskedTextField.displayName = 'CIS4mMaskedTextField';
